import { inviteHandler } from './configHandler.invite';
import { eipHandler } from './configHandler.eip';

const configHandler = (config) => {
    if (!config) {
        return;
    }
    if (config.chatInviteIconOptions) {
        inviteHandler(config);
    }
    if (config.eipOptions) {
        eipHandler(config);
    }
};

export { configHandler };
